/**
 * React hook for checking PostHog feature flag variants
 */

import { useState, useEffect } from 'react';
import { usePosthog } from './usePosthog';

/**
 * Hook to check if a feature flag is set to a specific variant
 * Returns true if the flag is set to the expected variant, false otherwise
 */
export const useFeatureFlagVariant = (
  flagKey: string,
  expectedVariant: string
): boolean => {
  const posthogService = usePosthog();
  const [isVariant, setIsVariant] = useState<boolean>(false);

  useEffect(() => {
    if (!posthogService) return;

    // Check initial variant value
    const checkVariant = () => {
      const isExpectedVariant = posthogService.isFeatureFlagVariant(flagKey, expectedVariant);
      setIsVariant(isExpectedVariant);
    };

    // Initial check
    checkVariant();

    // Set up listener for feature flag changes
    const handleFlagsUpdate = () => {
      checkVariant();
    };

    posthogService.onFeatureFlags(handleFlagsUpdate);

    // Reload flags to ensure we have the latest
    posthogService.reloadFeatureFlags();

    // No cleanup needed as PostHog handles listener cleanup internally
  }, [flagKey, expectedVariant, posthogService]);

  return isVariant;
};